import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../services';

@Component({
  selector: 'app-hotel-type',
  templateUrl: './hotel-type.component.html',
  styleUrls: ['./hotel-type.component.scss']
})
export class HotelTypeComponent implements OnInit {

  constructor(public data: DataService) { }

  hotelType = this.data.inputs
  ngOnInit(): void {
  }

}
